import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Endpoint } from '../../../../models/endpoint';
import { UrlService } from '../../../../services/util/url.service';
import { ClipboardService } from 'ngx-clipboard';

@Component({
    selector: 'app-endpoint-row',
    templateUrl: './endpoint-row.component.html',
    styleUrls: ['./endpoint-row.component.scss'],
    standalone: false
})
export class EndpointRowComponent implements OnInit {

  @Input() endpoint: Endpoint;
  @Input() gitlabendpoint: Endpoint;
  @Input() showCopyUrl: boolean;

  copy = false;

  constructor(public urlService: UrlService, private clipboardApi: ClipboardService) {
  }

  ngOnInit(): void {
  }

  onCopyId(data): void {
    this.copy = true;
    this.clipboardApi.copyFromContent(data);
    setTimeout(() => {
      this.copy = false;
    }, 500);
  }
}
